import { render, staticRenderFns } from "./ClientBlockages.vue?vue&type=template&id=85337794&scoped=true&"
import script from "./ClientBlockages.vue?vue&type=script&lang=js&"
export * from "./ClientBlockages.vue?vue&type=script&lang=js&"
import style0 from "./ClientBlockages.vue?vue&type=style&index=0&id=85337794&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "85337794",
  null
  
)

export default component.exports